import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { api } from "../lib/api";
import { useLocation } from "../lib/locationContext";
import { MapPin, Star } from "lucide-react";
import { Badge } from "../components/ui/badge";

const MapView = () => {
  const [restaurants, setRestaurants] = useState([]);
  const [selected, setSelected] = useState(null);
  const { location, locations } = useLocation();
  const currentLoc = locations.find(l => l.slug === location);

  useEffect(() => {
    api.get(`/restaurants?limit=100&location=${location}`).then(r => {
      const withCoords = r.data.filter(x => x.lat && x.lng);
      setRestaurants(withCoords);
      if (withCoords[0]) setSelected(withCoords[0]);
      else setSelected(null);
    });
  }, [location]);

  const mapSrc = selected
    ? `https://www.google.com/maps?q=${selected.lat},${selected.lng}&z=15&output=embed`
    : `https://www.google.com/maps?q=${encodeURIComponent(currentLoc?.name || "Indonesia")}&z=14&output=embed`;

  return (
    <div className="max-w-7xl mx-auto px-6 lg:px-8 py-12" data-testid="map-page">
      <div className="mb-8">
        <p className="text-xs uppercase tracking-[0.2em] font-bold text-muted-foreground">Eksplor Lokasi</p>
        <h1 className="font-heading text-4xl sm:text-5xl font-black mt-2">Peta Kuliner {currentLoc?.name || ""}</h1>
        <p className="text-muted-foreground mt-2">Klik restoran di kiri untuk lihat lokasi pada peta</p>
      </div>

      <div className="grid grid-cols-1 lg:grid-cols-12 gap-6">
        <div className="lg:col-span-4 space-y-3 max-h-[600px] overflow-y-auto" data-testid="map-restaurant-list">
          {restaurants.map(r => (
            <button
              key={r.id}
              onClick={() => setSelected(r)}
              data-testid={`map-item-${r.slug}`}
              className={`w-full text-left warm-card p-4 transition-all ${selected?.id === r.id ? "border-primary ring-2 ring-primary/20" : ""}`}
            >
              <div className="flex gap-3">
                <img src={r.cover_image} alt="" className="w-16 h-16 rounded-lg object-cover flex-shrink-0" />
                <div className="flex-1 min-w-0">
                  <h3 className="font-heading font-bold text-sm leading-tight">{r.name}</h3>
                  <Badge variant="secondary" className="text-[10px] mt-1">{r.category?.replace("-", " ")}</Badge>
                  <div className="flex items-center gap-1 mt-1 text-xs">
                    <Star className="w-3 h-3 fill-primary text-primary" />
                    <span className="font-semibold">{r.avg_rating?.toFixed(1) || "—"}</span>
                  </div>
                </div>
              </div>
            </button>
          ))}
        </div>

        <div className="lg:col-span-8 space-y-4">
          <div className="aspect-video lg:aspect-square rounded-2xl overflow-hidden border border-border">
            <iframe src={mapSrc} className="w-full h-full" allowFullScreen loading="lazy" referrerPolicy="no-referrer-when-downgrade" title="map" />
          </div>
          {selected && (
            <Link to={`/restaurants/${selected.slug}`} className="warm-card p-5 block hover:border-primary" data-testid="map-selected-info">
              <h3 className="font-heading font-black text-xl">{selected.name}</h3>
              <p className="text-sm text-muted-foreground mt-1 flex items-center gap-1"><MapPin className="w-4 h-4" /> {selected.address}</p>
              <p className="text-sm text-foreground/80 mt-2 line-clamp-2">{selected.description}</p>
              <span className="text-sm text-primary font-semibold mt-3 inline-block">Lihat detail →</span>
            </Link>
          )}
        </div>
      </div>
    </div>
  );
};

export default MapView;
